import { comics } from "@/mocks/comics";

export default function Finished() {
  const finished = comics.filter((c) => c.status === "完结");

  return (
    <section id="finished" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-sm font-semibold text-accent-700">一次追到底 · 告别催更</p>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">完结佳作</h2>
        </div>
        <p className="max-w-md text-sm text-foreground-600">
          已全部完结的作品，一口气读完不等待，适合假日补番。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
        {finished.map((c) => (
          <article
            key={c.id}
            className="group flex flex-col gap-4 rounded-lg bg-background-100 p-4 sm:flex-row md:p-5"
          >
            <div className="relative w-full shrink-0 overflow-hidden rounded-lg sm:w-40">
              <img
                src={c.cover}
                alt={`${c.title}漫画封面`}
                className="aspect-[3/4] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex min-w-0 flex-1 flex-col">
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap rounded-full bg-secondary-500 px-2.5 py-0.5 text-xs font-medium text-background-50">
                  已完结
                </span>
                <span className="whitespace-nowrap text-xs text-foreground-500">{c.latestChapter}</span>
              </div>
              <h3 className="mt-2 text-base font-semibold text-foreground-950 group-hover:text-primary-700">
                {c.title}
              </h3>
              <p className="mt-1 line-clamp-2 text-sm text-foreground-600">{c.description}</p>
              <div className="mt-auto flex flex-wrap items-center gap-2 pt-3">
                {c.categories.map((cat) => (
                  <span key={cat} className="whitespace-nowrap rounded-md bg-background-200 px-2 py-0.5 text-xs text-foreground-600">
                    {cat}
                  </span>
                ))}
                <span className="ml-auto whitespace-nowrap text-xs text-foreground-500">
                  <i className="ri-star-fill mr-0.5 text-secondary-400" aria-hidden="true"></i>
                  {c.rating}
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}